import { defineMessages } from "react-intl";

import TourDescriptor from "../types/TourDescriptor";

const messages = defineMessages({
  reporting1: {
    id: "guides.gettingStarted.checklist.reporting.step1",
    defaultMessage: "Stack Rank",
  },
  reporting1Description: {
    id: "guides.gettingStarted.checklist.reporting.step1.description",
    defaultMessage:
      "Here you can see how users are performing. You can change dates, filters, and the ranking metric.",
  },
  reporting2: {
    id: "guides.gettingStarted.checklist.reporting.step2",
    defaultMessage: "Stack Rank",
  },
  reporting2Description: {
    id: "guides.gettingStarted.checklist.reporting.step2.description",
    defaultMessage: "Here you can change a ranking metric. Please pick one to proceed.",
  },
  reporting3: {
    id: "guides.gettingStarted.checklist.reporting.step3",
    defaultMessage: "Dashboard",
  },
  reporting3Description: {
    id: "guides.gettingStarted.checklist.reporting.step3.description",
    defaultMessage:
      "You can create different widgets to see org, team and individual users' performance by different metrics and date ranges.",
  },
  reporting4: {
    id: "guides.gettingStarted.checklist.reporting.step4",
    defaultMessage: "Dashboard widgets",
  },
  reporting4Description: {
    id: "guides.gettingStarted.checklist.reporting.step4.description",
    defaultMessage:
      "The Dashboard consists of widgets which you can configure to show different data. You can also rearrange them using drag'n'drop and keep different order for different teams.",
  },
  reporting5: {
    id: "guides.gettingStarted.checklist.reporting.step5",
    defaultMessage: "Dashboard",
  },
  reporting5Description: {
    id: "guides.gettingStarted.checklist.reporting.step5.description",
    defaultMessage: "Feel free to add new widgets clicking on the + button",
  },
  reporting6: {
    id: "guides.gettingStarted.checklist.reporting.step6",
    defaultMessage: "Timeline",
  },
  reporting6Description: {
    id: "guides.gettingStarted.checklist.reporting.step6.description",
    defaultMessage:
      "Here you can see a list of all actions performed by user, team or the entire organization. Actions can include creating a record, sharing a file, check-ins, and many more.",
  },
  reporting7: {
    id: "guides.gettingStarted.checklist.reporting.step7",
    defaultMessage: "Timeline filters",
  },
  reporting7Description: {
    id: "guides.gettingStarted.checklist.reporting.step7.description",
    defaultMessage:
      "Choose which types of events you want to see, scroll to any date in the past, make events expanded or collapsed for ease of reading notes or navigation",
  },
});

export const adminsReportingTour: TourDescriptor = {
  id: "getting-started-admins-reporting",
  steps: [
    {
      id: "stack-rank",
      description: messages.reporting1Description,
      onBefore: async () => {
        // if sidebar collapsed, let's expand it
        const expandButton = document.querySelector(
          "[class*=Sidebar_expandable] [class*=Sidebar_fixButton]"
        );
        if (expandButton) {
          (expandButton as HTMLElement).click();
        }
      },
      position: "right",
      selector: "[data-id=dashboard-scopes]",
      title: messages.reporting1,
    },
    {
      id: "ranking-metric",
      description: messages.reporting2Description,
      options: {
        disableInteraction: false,
        showBackground: false,
        showButtons: false,
      },
      position: "right",
      selector: "[data-action-id=stack-rank-ranking-metric-menu]",
      title: messages.reporting2,
      waitForEvent: {
        eventType: "internal",
        selector: "Clicked: Dashboard -> Stack Rank -> Change ranking metric",
      },
    },
    {
      id: "dashboard-tab",
      description: messages.reporting3Description,
      selector: "[class*=DashboardTabs_tab] [data-node-key=dashboard]",
      title: messages.reporting3,
    },
    {
      id: "dashboard-cards",
      description: messages.reporting4Description,
      title: messages.reporting4,
    },
    {
      id: "dashboard-add",
      description: messages.reporting5Description,
      selector: "[class*=DashboardContent_addButtonContainer] button",
      title: messages.reporting5,
    },
    {
      id: "timeline-tab",
      description: messages.reporting6Description,
      goToPathBefore: "/dashboard/timeline",
      selector: "[class*=DashboardTabs_tab] [data-node-key=timeline]",
      title: messages.reporting6,
    },
    {
      id: "timeline-filter",
      description: messages.reporting7Description,
      position: "bottom",
      selector: "[class*=TimelineContent_filterBar]",
      title: messages.reporting7,
    },
  ],
};
